<div class="page-container">
  <app-card>
    <div class="error-state">
      <app-icon name="triangle-alert" [size]="64" color="var(--fg-danger)" />
      <h1>{{ 'syncError.title' | translate }}</h1>
      <p class="description">{{ 'syncError.description' | translate }}</p>

      <div class="warning-box">
        <app-icon name="circle-alert" color="var(--fg-warning)" />
        <div>
          <h3>{{ 'syncError.warning.title' | translate }}</h3>
          <p>{{ 'syncError.warning.description' | translate }}</p>
        </div>
      </div>

      <div class="actions">
        <app-button variant="filled" (click)="retry()">
          <app-icon name="refresh-cw" />
          {{ 'syncError.retry' | translate }}
        </app-button>
        <app-button variant="text" (click)="logout()">
          {{ 'syncError.logout' | translate }}
        </app-button>
      </div>
    </div>
  </app-card>
</div>